<template>
    <internal>
        <card-header
            :title="
                weekschedule.courseyear.course.title +
                ' - ' +
                weekschedule.courseyear.title +
                ' - ' +
                weekschedule.semester.title +
                ' - ' +
                weekschedule.batch.title
            "
        />
        <div
            class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg relative"
        >
            <loading :showLoading="form.processing" />

            <div
                :class="{
                    'opacity-50': form.processing,
                    'opacity-100': !form.processing,
                }"
            >
                <div class="flex justify-between items-center mb-4">
                    <p class="text-lg font-medium">Manage Schedule</p>
                    <breeze-button type="submit" @click="openSubjectModel()"
                        >Add Schedule</breeze-button
                    >
                </div>
                <form @submit.prevent="submitForm">
                    <div class="border-2 border-gray-900 rounded-md mb-4">
                        <div class="flex space-x-2">
                            <div class="py-2 w-20">
                                <div
                                    class="h-7 flex justify-center items-center font-medium mb-0 ml-2 rounded-md"
                                ></div>
                                <div
                                    class="ml-2 rounded-md text-sm my-2"
                                    v-for="(time, ind) in times"
                                    :key="ind"
                                >
                                    {{ time.formatted }}
                                </div>
                            </div>
                            <div class="w-full">
                                <div class="grid grid-cols-7 p-2">
                                    <div
                                        class="h-8 flex justify-center items-center font-medium rounded-md"
                                        v-for="(day, index) in days"
                                        :key="index"
                                    >
                                        {{ day }}
                                    </div>
                                </div>
                                <div class="relative">
                                    <div class="grid grid-cols-7">
                                        <div
                                            class=""
                                            v-for="(day, index) in days"
                                            :key="index"
                                        >
                                            <div
                                                class="text-center text-sm border border-black hover h-7 bg-white"
                                                v-for="(
                                                    time, ind
                                                ) in resolvedTime"
                                                :key="ind"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        class="absolute bg-indigo-400 w-[14.3%] p-2 border-2 border-indigo-700 cursor-pointer"
                                        @click="editLecture(index)"
                                        :class="[sch.top, sch.left, sch.height]"
                                        v-for="(sch, index) in form.schedule"
                                        :key="index"
                                    >
                                        <p class="text-white text-xs">
                                            {{ sch.subject.title }}
                                        </p>
                                        <p class="text-white text-xs">
                                            {{ sch.type }}
                                        </p>
                                        <p class="text-white text-xs">
                                            {{ sch.faculty.first_name }}
                                        </p>
                                        <p
                                            v-if="sch.assistant_faculty"
                                            class="text-white text-xs"
                                        >
                                            Asst.
                                            {{
                                                sch.assistant_faculty
                                                    ?.first_name
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span
                        v-if="form.recentlySuccessful"
                        class="text-green-500 mx-4"
                        >Schedule Saved Added!</span
                    >
                    <exception />
                </form>
            </div>
        </div>
    </internal>
    <model :isOpen="openModel" @close="openModel = false">
        <template #body>
            <div class="w-full">
                <div class="grid grid-cols-6 gap-4">
                    <div class="col-span-2 sm:col-span-2">
                        <FormMultiselect
                            :required="true"
                            :object="true"
                            label="Day"
                            :options="allDays"
                            track-key="id"
                            label-key="title"
                            placeholder="Select Day"
                            v-model="day"
                        />
                    </div>
                    <div class="col-span-2 sm:col-span-2">
                        <FormMultiselect
                            :required="true"
                            :object="true"
                            label="Start Time"
                            :options="allTimes"
                            placeholder="Select Start Time"
                            v-model="start_time"
                        />
                    </div>
                    <div class="col-span-2 sm:col-span-2">
                        <FormMultiselect
                            :required="true"
                            :object="true"
                            label="End Time"
                            :options="allTimes"
                            placeholder="Select End Time"
                            v-model="end_time"
                        />
                    </div>
                    <div class="col-span-3 sm:col-span-3">
                        <FormMultiselect
                            :required="true"
                            :object="true"
                            label="Subject"
                            :options="allSubjects"
                            placeholder="Select Subject"
                            v-model="subject"
                        />
                    </div>
                    <div class="col-span-3 sm:col-span-3">
                        <FormMultiselect
                            :required="true"
                            label="Faculty"
                            :options="branch.faculties"
                            track-key="id"
                            label-key="first_name"
                            :object="true"
                            v-model="faculty"
                        >
                            <template #label="{ item }">
                                {{ item.first_name }} {{ item.last_name }}
                            </template>
                        </FormMultiselect>
                    </div>
                    <div class="col-span-3 sm:col-span-3">
                        <FormMultiselect
                            :required="false"
                            label="Assistant Faculty"
                            :options="assistantFaculties"
                            track-key="id"
                            label-key="first_name"
                            :object="true"
                            v-model="assistant_faculty"
                        >
                            <template #label="{ item }">
                                {{ item.first_name }} {{ item.last_name }}
                            </template>
                        </FormMultiselect>
                    </div>
                    <div class="">
                        <breeze-label :value="'Theory'" />
                        <input-checkbox
                            class="rounded-full"
                            type="radio"
                            v-model="type"
                            name="type"
                            :value="'theory'"
                            :checked="type == 'theory'"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'Practical'" />
                        <input-checkbox
                            class="rounded-full"
                            type="radio"
                            v-model="type"
                            name="type"
                            :value="'practical'"
                            :checked="type == 'practical'"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'Software'" />
                        <input-checkbox
                            class="rounded-full"
                            type="radio"
                            v-model="type"
                            name="type"
                            :value="'software'"
                            :checked="type == 'software'"
                        />
                    </div>

                    <!-- <div class="">
                        <breeze-label :value="'Temporary'" />
                        <breeze-checkbox
                            v-model="mark_temp"
                            :checked="mark_temp"
                        />
                    </div>
                    <div class="col-span-2 sm:col-span-2" v-if="mark_temp">
                        <breeze-label :value="'Till Date'" />
                        <breeze-input v-model="temp_till_date" type="date" />
                    </div> -->
                </div>
            </div>
        </template>
        <template #buttons>
            <div class="flex flex-col flex-1 gap-2">
                <div class="flex justify-between items-center flex-1">
                    <div>
                        <button
                            type="button"
                            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 text-base font-medium text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                            @click="onDeleteClick"
                            ref="cancelButtonRef"
                        >
                            Delete
                        </button>
                    </div>

                    <div>
                        <button
                            type="button"
                            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 text-base font-medium text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            @click="onCancelClick"
                            ref="cancelButtonRef"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 disabled:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            v-if="subjectIndex === ''"
                            @click="addSubject"
                            ref="cancelButtonRef"
                            :disabled="
                                !subject ||
                                !faculty ||
                                !type ||
                                (mark_temp && !temp_till_date)
                            "
                            :class="{
                                'bg-white':
                                    (subject && faculty && type) ||
                                    (mark_temp && temp_till_date),
                                'bg-gray-50':
                                    !subject ||
                                    !faculty ||
                                    !type ||
                                    (mark_temp && !temp_till_date),
                            }"
                        >
                            Add
                        </button>
                        <button
                            type="button"
                            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 disabled:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            v-else
                            @click="updateSubject(subjectIndex)"
                            ref="cancelButtonRef"
                            :disabled="
                                !subject ||
                                !faculty ||
                                !type ||
                                (mark_temp && !temp_till_date)
                            "
                            :class="{
                                'bg-white':
                                    (subject && faculty && type) ||
                                    (mark_temp && temp_till_date),
                                'bg-gray-50':
                                    !subject ||
                                    !faculty ||
                                    !type ||
                                    (mark_temp && !temp_till_date),
                            }"
                        >
                            Update
                        </button>
                    </div>
                </div>

                <div
                    v-if="duplicateLectureError"
                    class="text-red-500 text-sm w-full text-left"
                >
                    {{ duplicateLectureError }}
                </div>
            </div>
        </template>
    </model>
</template>

<script>
import Internal from "@/Pages/Internal/Internal";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import ButtonLink from "@/Components/ButtonLink";
import CardHeader from "@/Components/CardHeader";
import { useForm } from "@inertiajs/inertia-vue3";
import BreezeInputError from "@/Components/InputError";
import BreezeButton from "@/Components/Button";
import InputCheckbox from "@/Components/InputCheckbox";
import BreezeCheckbox from "@/Components/Checkbox";
import Loading from "@/Components/Loading";
import SelectList from "@/Components/SelectList";
import Exception from "@/Components/Exception";
import Model from "@/Components/Model";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import { Inertia } from "@inertiajs/inertia";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Internal,
        BreezeInput,
        BreezeLabel,
        ButtonLink,
        CardHeader,
        BreezeInputError,
        BreezeButton,
        InputCheckbox,
        BreezeCheckbox,
        Loading,
        Exception,
        SelectList,
        Model,
        Switch,
        SwitchGroup,
        SwitchLabel,
    },
    props: ["weekschedule", "branch", "subjects", "times", "lectures"],
    data() {
        return {
            form: useForm({
                schedule: [],
            }),
            branchid: localStorage.branchId,
            openModel: false,
            selected: [],
            allfaculties: [],
            day: "",
            start_time: "",
            end_time: "",
            subject: "",
            faculty: "",
            assistant_faculty: "",
            type: "theory",
            mark_temp: false,
            temp_till_date: false,
            subjectIndex: "",
            duplicateLectureError: "",
        };
    },
    methods: {
        submitForm() {
            this.form.post(
                route("internal.weekschedule.schedule.store", [
                    this.branchid,
                    this.weekschedule.id,
                ]),
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.reset();
                        location.reload();
                    },
                }
            );
        },
        openSubjectModel() {
            this.openModel = true;
        },
        addSubject() {
            // Check if start time equals end time
            if (this.start_time.unformatted === this.end_time.unformatted) {
                this.duplicateLectureError =
                    "Start time and end time cannot be the same.";
                return;
            }

            // Check for exact duplicate
            const existingLectureIndex = this.lectures.findIndex(
                (lecture) =>
                    lecture.day === this.day.title &&
                    lecture.start_time === this.start_time.unformatted &&
                    lecture.end_time === this.end_time.unformatted
            );

            if (existingLectureIndex !== -1) {
                this.duplicateLectureError =
                    "Lecture already exists for this slot.";
                return;
            }

            // Check for overlapping time slots
            const dayLectures = this.lectures.filter(
                (lecture) => lecture.day === this.day.title
            );

            for (const lecture of dayLectures) {
                const existingStart = lecture.start_time;
                const existingEnd = lecture.end_time;

                if (
                    (this.start_time.unformatted < existingEnd &&
                        this.end_time.unformatted > existingStart) ||
                    this.start_time.unformatted === existingStart ||
                    this.end_time.unformatted === existingEnd
                ) {
                    this.duplicateLectureError =
                        "This time slot conflicts with an existing lecture.";
                    return;
                }
            }

            // Persist immediately
            const payload = {
                schedule: [
                    {
                        day: this.day.title,
                        start_time: this.start_time.unformatted,
                        end_time: this.end_time.unformatted,
                        subject: this.subject,
                        faculty: this.faculty,
                        assistant_faculty: this.assistant_faculty,
                        type: this.type,
                        mark_temp: this.mark_temp,
                        till_date: this.temp_till_date,
                    },
                ],
            };
            Inertia.post(
                route("internal.weekschedule.schedule.store", [
                    this.branchid,
                    this.weekschedule.id,
                ]),
                payload,
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.resetModelState();
                        location.reload();
                    },
                }
            );
        },
        updateSubject(index) {
            // Check if start time equals end time
            if (this.start_time.unformatted === this.end_time.unformatted) {
                this.duplicateLectureError =
                    "Start time and end time cannot be the same.";
                return;
            }

            // Check for overlapping time slots (excluding the current lecture being edited)
            const dayLectures = this.lectures.filter(
                (lecture, lectureIndex) =>
                    lecture.day === this.day.title && lectureIndex !== index
            );

            for (const lecture of dayLectures) {
                const existingStart = lecture.start_time;
                const existingEnd = lecture.end_time;

                if (
                    (this.start_time.unformatted < existingEnd &&
                        this.end_time.unformatted > existingStart) ||
                    this.start_time.unformatted === existingStart ||
                    this.end_time.unformatted === existingEnd
                ) {
                    this.duplicateLectureError =
                        "This time slot conflicts with an existing lecture.";
                    return;
                }
            }

            // Persist update immediately using the lecture id
            const current = this.form.schedule[index];
            const payload = {
                schedule: [
                    {
                        id: current.id,
                        day: this.day.title,
                        start_time: this.start_time.unformatted,
                        end_time: this.end_time.unformatted,
                        subject: this.subject,
                        faculty: this.faculty,
                        assistant_faculty: this.assistant_faculty,
                        type: this.type,
                        mark_temp: this.mark_temp,
                        till_date: this.temp_till_date,
                    },
                ],
            };

            Inertia.post(
                route("internal.weekschedule.schedule.store", [
                    this.branchid,
                    this.weekschedule.id,
                ]),
                payload,
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.resetModelState();
                        location.reload();
                    },
                }
            );
        },
        onDeleteClick() {
            // If editing existing lecture, delete. Otherwise just close.
            if (this.subjectIndex === "") {
                this.onCancelClick();
                return;
            }
            const current = this.form.schedule[this.subjectIndex];
            const payload = {
                schedule: [
                    {
                        id: current.id,
                        delete: true,
                    },
                ],
            };
            Inertia.post(
                route("internal.weekschedule.schedule.store", [
                    this.branchid,
                    this.weekschedule.id,
                ]),
                payload,
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.resetModelState();
                        location.reload();
                    },
                }
            );
        },
        onCancelClick() {
            this.resetModelState();
            this.openModel = false;
        },
        resetModelState() {
            this.openModel = false;
            this.duplicateLectureError = "";
            this.day = "";
            this.start_time = "";
            this.end_time = "";
            this.subject = "";
            this.faculty = "";
            this.assistant_faculty = "";
            this.type = "theory";
            this.mark_temp = false;
            this.temp_till_date = false;
            this.subjectIndex = "";
        },
        getSchedule() {
            var schedule = [];
            this.lectures.forEach((data) => {
                schedule.push({
                    day: data.day,
                    start_time: data.start_time,
                    end_time: data.end_time,
                    subject: data.subject
                        ? { id: data.subject.id, title: data.subject.title }
                        : null,
                    faculty: data.faculty
                        ? {
                              id: data.faculty.id,
                              first_name:
                                  data.faculty.first_name +
                                  " " +
                                  data.faculty.last_name,
                          }
                        : null,
                    assistant_faculty: data.assistant_faculty
                        ? {
                              id: data.assistant_faculty.id,
                              first_name:
                                  data.assistant_faculty.first_name +
                                  " " +
                                  data.assistant_faculty.last_name,
                          }
                        : null,
                    type: data.type,
                    id: data.id,
                    temp_lecture: data.temp_lecture,
                    left: this.calculateLeft(data.day),
                    top: this.calculateTop(data.start_time),
                    height: this.calculateHeight(
                        data.start_time,
                        data.end_time
                    ),
                });
            });
            return schedule;
        },
        calculateTop(starttime, formatted = false) {
            if (formatted) {
                let key = Object.keys(this.times).find(
                    (key) => starttime === this.times[key].formatted
                );
                // key--
                return "top-0" + key;
            } else {
                let key = Object.keys(this.times).find(
                    (key) => starttime === this.times[key].unformatted
                );
                // key--
                return "top-0" + key;
            }
        },
        calculateLeft(day) {
            let key = Object.keys(this.days).find(
                (key) => day === this.days[key]
            );
            return "left-0" + key;
        },
        calculateHeight(start_time, end_time) {
            let startkey = Object.keys(this.times).find(
                (key) => start_time === this.times[key].unformatted
            );
            let endkey = Object.keys(this.times).find(
                (key) => end_time === this.times[key].unformatted
            );
            switch (endkey - startkey) {
                case 1:
                    return "h-01";
                    break;
                case 2:
                    return "h-02";
                    break;
                case 3:
                    return "h-03";
                    break;
                case 4:
                    return "h-04";
                    break;
                case 5:
                    return "h-05";
                    break;
                case 6:
                    return "h-06";
                    break;
                case 7:
                    return "h-07";
                    break;
                case 8:
                    return "h-08";
                    break;
                case 9:
                    return "h-09";
                    break;
                case 10:
                    return "h-10";
                    break;
            }
        },

        getAvailableFaculty() {
            if (!this.day || !this.start_time) {
                return;
            }
            window.axios
                .get(
                    route("internal.weekschedule.getteachers", [
                        this.branchid,
                        this.weekschedule.id,
                    ]),
                    {
                        params: {
                            day: this.day.title,
                            start_time: this.start_time.title,
                        },
                    }
                )
                .then((res) => {
                    this.allfaculties = res.data;
                });
        },
        editLecture(index) {
            let lecture = this.form.schedule.find((lec, ind) => ind === index);
            const day = this.allDays.find((item) => item.title == lecture.day);

            this.day = day;
            this.start_time = this.allTimes.find(
                (t) => t.unformatted == lecture.start_time
            );
            this.end_time = this.allTimes.find(
                (t) => t.unformatted == lecture.end_time
            );
            this.subject = lecture.subject;
            this.faculty = lecture.faculty;
            this.assistant_faculty = lecture.assistant_faculty || "";
            this.type = lecture.type;
            this.subjectIndex = index;
            this.mark_temp = lecture.mark_temp;
            this.temp_till_date = lecture.mark_temp;
            this.openModel = true;
        },
    },
    computed: {
        days() {
            return [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
            ];
        },
        faculties() {
            var faculties = [];
            this.allfaculties.forEach((faculty) => {
                faculties.push({
                    id: faculty.id,
                    title:
                        faculty.first_name +
                        " " +
                        faculty.middle_name +
                        " " +
                        faculty.last_name,
                });
            });
            return faculties;
        },
        allSubjects() {
            var allSubjects = [];
            this.subjects.forEach((subject) => {
                allSubjects.push({ id: subject.id, title: subject.title });
            });
            return allSubjects;
        },
        resolvedTime() {
            return this.times.slice(0, -1);
        },
        allDays() {
            var days = [];
            this.days.forEach((day, index) => {
                days.push({ id: index + 1, title: day });
            });
            return days;
        },
        allTimes() {
            var times = [];
            this.times.forEach((time, index) => {
                times.push({
                    id: index + 1,
                    title: time.formatted,
                    unformatted: time.unformatted,
                });
            });
            return times;
        },
        assistantFaculties() {
            if (!this.faculty) return this.branch.faculties;
            return this.branch.faculties.filter(
                (f) => f.id !== this.faculty.id
            );
        },
    },
    watch: {
        faculty(newFaculty) {
            if (
                this.assistant_faculty &&
                newFaculty &&
                this.assistant_faculty.id === newFaculty.id
            ) {
                this.assistant_faculty = "";
            }
        },
    },
    beforeMount() {
        this.form.schedule = this.getSchedule();
    },
};
</script>
<style>
.hover-show {
    display: none;
}

.hover:hover .hover-show {
    display: block;
}

.top-00 {
    top: 0;
}

.top-01 {
    top: 27px;
}

.top-02 {
    top: 55px;
}

.top-03 {
    top: 83px;
}

.top-04 {
    top: 111px;
}

.top-05 {
    top: 129px;
}

.top-06 {
    top: 167px;
}

.top-07 {
    top: 195px;
}

.top-08 {
    top: 223px;
}

.top-09 {
    top: 251px;
}

.top-010 {
    top: 279px;
}

.top-011 {
    top: 307px;
}

.top-012 {
    top: 335px;
}

.top-013 {
    top: 363px;
}

.top-014 {
    top: 391px;
}

.top-015 {
    top: 419px;
}

.top-016 {
    top: 447px;
}

.top-017 {
    top: 475px;
}

.top-018 {
    top: 503px;
}

.top-019 {
    top: 531px;
}

.top-020 {
    top: 559px;
}

.top-021 {
    top: 581px;
}

.top-022 {
    top: 609px;
}

.top-023 {
    top: 637px;
}

.top-024 {
    top: 665px;
}

.top-025 {
    top: 693px;
}

.left-00 {
    left: 0;
}

.left-01 {
    left: 14.3%;
}

.left-02 {
    left: 28.6%;
}

.left-03 {
    left: 42.9%;
}

.left-04 {
    left: 57.2%;
}

.left-05 {
    left: 71.5%;
}

.left-06 {
    left: 85.8%;
}

.h-01 {
    height: 29px;
}

.h-02 {
    height: 58px;
}

.h-03 {
    height: 85px;
}

.h-04 {
    height: 113px;
}

.h-05 {
    height: 141px;
}

.h-06 {
    height: 169px;
}

.h-07 {
    height: 197px;
}

.h-08 {
    height: 225px;
}

.h-09 {
    height: 253px;
}

.h-10 {
    height: 281px;
}
</style>
